// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"i4-z","dimensionLabel":"j4-z","styleChooserControlWrapper":"k4-z","styleChooserControl":"l4-z","disabled":"m4-z","giftCard":"n4-z","styleChooserText":"o4-z"};